import React from "react";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import "./style.css";
import marioBio from "../../../static/img/about-us/Mario_Headshot 2024015.png";
import nikBio from "../../../static/img/about-us/Nik_Headshot 2024005.jpg";
import steveBio from "../../../static/img/about-us/Steve_Headshot 2024003.png";
import anthonyyBio from "../../../static/img/about-us/anthony_hs.jpg";
import anyBio from "../../../static/img/about-us/Smith_Jennifer.jpg";


export const AboutUsPage = () => {
    return (
        <div className="main aboutUs" id="about">
                    <div className="overlap">
                    <div className="content">
                        <div className="element hero bg-white">
                            <div className="frame">
                                <p className="heading color-black">
                                Welcome to recruit22, a forward-thinking recruitment firm built for the modern age. 
                                </p>
                                <p className="heading2 color-black">
                                    In today's rapidly evolving business landscape, finding top talent has become increasingly complex, which is why we have reimagined the traditional recruitment process.
                                </p>
                            </div>
                            <div className="image">
                                <div className="group">
                                    <div className="rectangle" />
                                </div>
                            </div>
                        </div>
                        <div className="element bg-white">
                            <div className="frame">
                            <p className="heading color-black">
                            Meet the Team
                            </p>
                                <div className="aboutUs-segment">
        
                                    <div className="aboutUs-block">
                                        <div className="aboutUs-title">
                                            <div className="block-title color-black">
                                            <a href="https://www.linkedin.com/in/mario-a-duran/" target="_blank" className="slink">
                                                Mario Duran</a>
                                            <p className="aboutUs-text block-text">Founder - COO and Technology Delivery</p>
                                            </div>
                                        </div>
                                        <div className="aboutUs-text">
                                            <div className="block-text color-black">
                                                <div className="pictureBio">
                                                <img src={marioBio} 
                                                className="pictureBio-img"
                                                />
                                                </div>
                                                <p>
                                               Mario Duran is a seasoned technology executive with over 20 years of software development expertise, 
                                               currently serving as Chief Operating Officer of recruit22 and Chief Technology Officer of The Dandelion Philosophy. 
                                               Throughout his career, he has excelled in transforming complex business requirements into effective digital 
                                               solutions across financial services, government, and healthcare sectors. Mario combines strategic leadership 
                                               with technical proficiency, as well as artificial intelligence and cloud infrastructure. His strengths include 
                                               full lifecycle software development management, cross-functional team leadership, and designing scalable technology
                                            solutions that drive business growth. As a leader, Mario consistently delivers innovative approaches
                                                to digital transformation while maintaining operational excellence and strong stakeholder relationships.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                     <div className="aboutUs-block">
                                        <div className="aboutUs-title">
                                            <div className="block-title color-black">
                                            <a href="https://www.linkedin.com/in/nikfikaj/" target="_blank" className="slink">
                                                Nik Fikaj</a>
                                            <p className="aboutUs-text block-text">Partner - ATS Development</p>
                                            </div>
                                        </div>
                                        <div className="aboutUs-text">
                                            <div className="block-text color-black">
                                                <div className="pictureBio">
                                                <img src={nikBio} 
                                                className="pictureBio-img"
                                                />
                                                </div>
                                                <p>
                                               Nik Fikaj is an accomplished recruiting leader with extensive experience in technical recruiting and executive search across the healthcare, technology, and finance sectors.
                                                With a strong background in diversity-focused technical recruiting and senior engineering talent acquisition at leading tech companies, Nik brings valuable expertise to his current roles. 
                                                As an advisor and Applicant Tracking System (ATS) development leader at recruit22, he provides strategic guidance on recruitment technology implementation, focusing on designing intuitive
                                                 ATS solutions that streamline recruitment processes and enhance data-driven hiring decisions. His comprehensive understanding of both technical requirements and talent acquisition has
                                                  enabled him to successfully lead global recruiting efforts and build high-performing teams across international boundaries.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                  

                                     <div className="aboutUs-block">
                                        <div className="aboutUs-title">
                                            <div className="block-title color-black">
                                            <a href="https://www.linkedin.com/in/anthonyebutler/" target="_blank">
                                                Anthony Butler</a>
                                            </div>
                                            <p className="aboutUs-text block-text">Partner - Technical + Relationship B2B Sales Professional</p>
                                        </div>
                                        <div className="aboutUs-text">
                                            <div className="block-text color-black">
                                                <div className="pictureBio">
                                                <img src={anthonyyBio} 
                                                className="pictureBio-img"
                                                />
                                                </div>
                                                <p>
                                               Anthony Butler is a distinguished Talent Solutions Partner at recruit22, bringing over a decade of strategic 
                                               technology sales expertise to our recruitment ecosystem. With a proven track record of connecting top-tier 
                                               technology professionals to enterprise-scale solutions, Anthony leverages his deep industry insights to drive 
                                               innovative talent acquisition strategies. His extensive experience with leading technology companies like 
                                               Forcepoint and SolarWinds has equipped him with a unique perspective on matching exceptional technical 
                                               talent with transformative organizational needs. As a key partner at recruit22, Anthony specializes in 
                                               developing comprehensive recruitment solutions that bridge the gap between cutting-edge technology professionals and forward-thinking enterprises.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="aboutUs-block">
                                        <div className="aboutUs-title">
                                            <div className="block-title color-black">
                                            <a href="https://www.linkedin.com/in/jennifer-ryan-30/" target="_blank">
                                               Jennifer Smith</a>
                                            </div>
                                            <p className="aboutUs-text block-text">Recruiting Partner </p>
                                        </div>
                                        <div className="aboutUs-text">
                                            <div className="block-text color-black">
                                                <div className="pictureBio">
                                                <img src={anyBio} 
                                                className="pictureBio-img"
                                                />
                                                </div>
                                                <p>
                                               Jennifer Smith is a dynamic passionate recruiting professional with over 10 years of experience in talent acquisition. 
                                               Specializing in full-cycle recruitment across technology and business sectors, she has successfully hired over 200 employees 
                                               for prominent companies including C.H. Robinson, GoHealth, and Foot Locker.
                                                With a strategic approach to talent acquisition, Jennifer excels in sourcing top-tier candidates, building robust relationships with hiring managers, 
                                                and developing recruitment strategies that precisely align with organizational objectives.
                                                Throughout her career, Jennifer has demonstrated a consistent ability to identify and attract exceptional talent that drives organizational growth and success. 
                                                Her deep understanding of both technical and business sector recruitment enables her to match exceptional candidates with roles that leverage their unique skills and potential. Let's work together.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="aboutUs-block">
                                        <div className="aboutUs-title">
                                            <div className="block-title color-black">
                                            <a href="https://www.linkedin.com/in/steven-skene-6686555/" target="_blank">
                                               Steve Skene</a>
                                            </div>
                                            <p className="aboutUs-text block-text">Senior Technical Recruiter</p>
                                        </div>
                                        <div className="aboutUs-text">
                                            <div className="block-text color-black">
                                                <div className="pictureBio">
                                                <img src={steveBio} 
                                                className="pictureBio-img"
                                                />
                                                </div>
                                                <p>
                                               Steven Skene is a seasoned Senior Technical Recruiter with over 15 years of extensive experience in IT recruitment and talent acquisition. 
                                               Throughout his career, he has demonstrated exceptional skills in full-lifecycle recruiting, having worked with prominent organizations across various industries. 
                                               Specializing in IT and technology roles, Steven has successfully recruited for diverse positions including Project Managers, Business Analysts, Developers, and Tech Writers. 
                                               With a Bachelor’s in Human Resources Development from a renowned university and an Associate Degree in Business Management, he brings a comprehensive approach to talent acquisition, 
                                               excelling in building strong client relationships, negotiating offers, and developing robust recruitment strategies across multiple sectors.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
        
                                </div>
                            </div>
                        </div>
                         <div className="element bg-gray">
                                <div className="frame">
                                    <p className="heading color-black">
                                    What we do
                                    </p>
                                    <div className="group-whatwedo image-centered" />
                                     <div className="aboutUs-segment">
                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Navigating Modern Recruitment Challenges
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    In a hyper-connected world where talent is in high demand, we offer strategic solutions to help you find the right candidates efficiently. 
                                                    We use cutting-edge technologies and data-driven methodologies to provide a competitive edge in talent acquisition.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Comprehensive Talent Solutions
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    We go beyond traditional recruitment practices to connect organizations with candidates who bring valuable perspectives and skills. 
                                                    Our approach ensures equal opportunities throughout the hiring process.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Leveraging Technology
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    We use AI-powered tools, machine learning algorithms, and data analytics to identify qualified candidates. 
                                                    This approach enables us to discover hidden talent pools and make data-backed decisions throughout the recruitment process.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Agile Solutions
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    In an era of remote work, gig economy, and evolving skill sets, we source flexible talent for project-based assignments, 
                                                    contract roles, or remote work opportunities. Our solutions align with the changing dynamics of the modern workforce.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Building Connections
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    While technology is powerful, we value human connection. Our team combines technology with personalized service to understand 
                                                    your organization’s culture, values, and goals, ensuring candidates are both skills and cultural fits.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-black">
                                                    Shaping the Future
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-black"> 
                                                    We are passionate about innovation and challenging the status quo. Partner with us to access top talent and overcome modern recruitment challenges.
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="element bg-dark-blue">
                                <div className="frame">
                                    <p className="heading color-white">
                                    What we think
                                    </p>
                                    <p className="heading2 color-white">
                                    Our vision is to transform recruitment by harnessing technology and creating opportunities in the evolving job market.
                                    </p>
                                    <div className="group-whatwethink image-centered" />
                                    <div className="aboutUs-segment">
                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-white">
                                                    Excellence in Recruitment
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-white"> 
                                                    We believe in building strong teams that drive organizational success. We create a recruitment ecosystem 
                                                    that celebrates a breadth of perspectives and experiences, helping companies build well-rounded teams.
                                                </div>
                                               
                                            </div>
                                            
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-white">
                                                    Creating Effective Workplaces
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-white"> 
                                                    We envision environments where every employee feels valued and empowered. Our commitment goes beyond matching skills; 
                                                    we create workplaces where talent can thrive, driving innovation and fostering collaboration.
                                                </div>
                                               
                                            </div>
                                            
                                        </div>

                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-white">
                                                    Supporting Talent Development
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-white"> 
                                                    We are dedicated to providing opportunities for professional growth through tailored support, 
                                                    mentorship, and guidance to help candidates excel and become leaders in their fields.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-white">
                                                    Technology as an Enabler
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-white"> 
                                                    We leverage cutting-edge technologies and data-driven insights to revolutionize talent acquisition, 
                                                    streamline processes, and uncover untapped talent pools.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="aboutUs-block">
                                            <div className="aboutUs-title">
                                                <div className="block-title color-white">
                                                    Together, We Shape the Future
                                                </div>
                                            </div>
                                            <div className="aboutUs-text">
                                                <div className="block-text color-white"> 
                                                    We are committed to driving positive change where innovation and technology converge to create thriving organizations and unlock individual potential.
                                                </div>
                                               
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>
                            </div>
                        <Footer
                            footer="default"
                        />
                    </div>
                    <Nav className="nav-instance" nav="default" />
                    </div>
                </div>
    );
};
